import React from 'react';

import Glyphicon from 'react-bootstrap/lib/Glyphicon';
import TouchLink from '../../components/TouchLink';

const Element = React.createClass({
	render() {

		const className = this.props.className;
		const element = this.props.element;

		return (element === 'li' ? <li className={className}>{this.props.children}</li> : <div className={className}>{this.props.children}</div>);
	}
});

const Link = React.createClass({
	render() {

		const to = this.props.to;
		const className = this.props.className;

		return(to ? <TouchLink to={to} className={className}>{this.props.children}</TouchLink> : <div className={className}>{this.props.children}</div>);

	}
});

const ChapterItem = React.createClass({
	render() {
		const element = this.props.element || 'div';
		const to = this.props.to;
		const label = this.props.label;
		const recommended = this.props.recommended || false;
		const progressbar = this.props.progressbar;
		const icon = this.props.icon ? this.props.icon.toLowerCase() : "";

		let graphic = null;

		if(icon) {
			graphic = ` graphic graphic--${icon}`;
		}

		return (
			<Element element={element} className={`chapters-item`}>
				<Link to={to} className={`chapters-item-link`}>
					<div className={`chapters-item-graphic${graphic}`}></div>
					<div className={`chapters-item-text`}>
						<span className="chapters-item-label">{label}</span>
						{progressbar ? <span className="chapter-progress"><span className="chapter-progress-fill" style={{width: progressbar + '%'}}></span></span> : null}
						{recommended ? <span className="recommended">Recommended <Glyphicon glyph="thumbs-up"/></span> : null}
					</div>
				</Link>
				{this.props.children}
			</Element>
		);
	}
});

export default ChapterItem;


/** WEBPACK FOOTER **
 ** ./src/components/ChapterItem/ChapterItem.js
 **/